const scriptUtils = {
    loadQualaroo() {
        window._kiq = window._kiq || [];

        if (typeof window.KI === 'undefined') {
            const d = document;
            const f = d.getElementsByTagName('script')[0];
            const s = d.createElement('script');

            s.async = true;
            s.type = 'text/javascript';
            s.src = '//s3.amazonaws.com/ki.js/51812/bxH.js';
            f.parentNode.insertBefore(s, f);
        }
    },
    loadScript(src, id = '') {
        return new Promise((resolve, reject) => {
            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            script.id = id;
            script.type = 'text/javascript';
            script.onload = () => resolve(true);
            script.onerror = () => {
                const error = new Error(`loading script ${src}`);
                console.error(error);
                reject(error);
            };
            script.src = src;
            head.appendChild(script);
        });
    },
};

export default scriptUtils;
